import { render, staticRenderFns } from "./AddImageAlbumsChat.vue?vue&type=template&id=12696db6&scoped=true&lang=html&"
import script from "./AddImageAlbumsChat.vue?vue&type=script&lang=js&"
export * from "./AddImageAlbumsChat.vue?vue&type=script&lang=js&"
import style0 from "./AddImageAlbumsChat.vue?vue&type=style&index=0&id=12696db6&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12696db6",
  null
  
)

export default component.exports